import { syncUserCartForRecommendations } from 'api/cart/syncUserCardForRecommendations'
import { putUserCart } from 'api/cart/userCart'
import debounce from 'lodash.debounce'

function saveUserCart(userCartState: App.UserCartState, le_user_id?: string, domain_user_id?: string, isSpoofed: boolean = false) {
  putUserCart(userCartState).catch(err => console.error(err))
  if (!isSpoofed) {
    syncUserCartForRecommendations(userCartState, le_user_id, domain_user_id)
  }
}

export const saveUserCartDebounced = debounce(saveUserCart, 300)
